import ErrorPresenter from '../service/ErrorPresenter';
import ErrorReporter from '../service/ErrorReporter';

class ApiErrorHandler {
  private errorPresenter: ErrorPresenter;
  private errorReporter: ErrorReporter;

  constructor({ errorPresenter, errorReporter }: { errorPresenter: ErrorPresenter; errorReporter: ErrorReporter }) {
    this.errorPresenter = errorPresenter;
    this.errorReporter = errorReporter;
  }

  ERRORS_4XX = ['active_record/record_invalid'];

  public handle = (err: Error | any) => {
    if (err.response && err.response.data && err.response.data.code) {
      // const code = err.response.data.code;
      const error: any = new Error(err.response.data.error);
      error.is_raw = true;
      this.errorPresenter.showAsNonFatal(error);
    } else {
      console.log(err);
      this.errorReporter.reportError(err);
      this.errorPresenter.showAsFatal(new Error('error.system_error'));
    }
  };

  public handleChartApi = (err: Error | any, chartName: string) => {
    if (err.response && err.response.data && err.response.data.code) {
      // const code = err.response.data.code;
      const error: any = new Error(err.response.data.error);
      error.is_raw = true;
      this.errorPresenter.showAsNonFatal(error);
    } else {
      this.errorPresenter.showAsNonFatal(new Error(`${chartName}の取得に失敗しました`));
    }
  };

  public handleMutationError = (err: Error | any, message: string) => {
    if (err.response && err.response.data && err.response.data.code) {
      // const code = err.response.data.code;
      const error: any = new Error(err.response.data.error);
      error.is_raw = true;
      this.errorPresenter.showAsNonFatal(error);
    } else {
      this.errorPresenter.showAsNonFatal(new Error(`${message}`));
    }
  };
}

export default ApiErrorHandler;
